import { Locale, type LocalizedString } from "../Locale.js";
import { Service, type ServiceWithPage } from "../Service.js";

export const servicesNameMap = {
	[Locale.cs]: "Služby",
	[Locale.en]: "Services",
	[Locale.pl]: "Usługi",
	[Locale.sk]: "Služby",
} satisfies LocalizedString;

export const serviceCategoryNameMap: Record<Service, LocalizedString> = {
	[Service.Integration]: {
		[Locale.cs]: "Integrace",
		[Locale.en]: "Integration",
		[Locale.pl]: "Integracja",
		[Locale.sk]: "Integrácia",
	},
	[Service.Consultation]: {
		[Locale.cs]: "Konzultace",
		[Locale.en]: "Consultation",
		[Locale.pl]: "Konsultacje",
		[Locale.sk]: "Poradenstvo",
	},
	[Service.Service]: {
		[Locale.cs]: "Servis a podpora",
		[Locale.en]: "Service and Support",
		[Locale.pl]: "Serwis i wsparcie",
		[Locale.sk]: "Servis a podpora",
	},
	[Service.Financing]: {
		[Locale.cs]: "Financování",
		[Locale.en]: "Financing",
		[Locale.pl]: "Finansowanie",
		[Locale.sk]: "Financovanie",
	},
};

export const serviceWithPageNameMap: Record<ServiceWithPage, LocalizedString> = {
	[Service.Integration]: serviceCategoryNameMap[Service.Integration],
	[Service.Service]: serviceCategoryNameMap[Service.Service],
};
